import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import { __decorate } from "tslib";
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { Component, Vue } from 'vue-property-decorator';
import { preferenCoupon, receiveCoupon as _receiveCoupon } from '@/services/http';
import { readCookie, dateTimeFormatter as _dateTimeFormatter } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.couponList = {}; // 优惠券信息
    _this.isEmpity = false;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getCouponList();
    }
    // 获取优惠券列表
  }, {
    key: "getCouponList",
    value: function () {
      var _getCouponList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return preferenCoupon({
                couponId: this.$route.query.id
              });
            case 2:
              res = _context.sent;
              if (res.data.code === 100) {
                this.couponList = res.data.data;
                this.isEmpity = Object.keys(this.couponList).length === 0;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCouponList() {
        return _getCouponList.apply(this, arguments);
      }
      return getCouponList;
    }() // 领取优惠券
  }, {
    key: "receiveCoupon",
    value: function () {
      var _receiveCoupon2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!item.receive) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!readCookie('accessToken')) {
                _context2.next = 9;
                break;
              }
              _context2.next = 5;
              return _receiveCoupon({
                couponId: item.id,
                productId: ''
              });
            case 5:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.$message.success('领取成功');
                this.getCouponList();
              } else {
                this.$message.error(res.data.message);
              }
              _context2.next = 10;
              break;
            case 9:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function receiveCoupon(_x) {
        return _receiveCoupon2.apply(this, arguments);
      }
      return receiveCoupon;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  },
  filters: {
    dateTimeFormatter: function dateTimeFormatter(value) {
      return _dateTimeFormatter(value);
    }
  }
})], default_1);
export default default_1;